import { render, staticRenderFns } from "./OldDashboadCopy.vue?vue&type=template&id=8821be16&scoped=true&"
import script from "./OldDashboadCopy.vue?vue&type=script&lang=js&"
export * from "./OldDashboadCopy.vue?vue&type=script&lang=js&"
import style0 from "./OldDashboadCopy.vue?vue&type=style&index=0&id=8821be16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8821be16",
  null
  
)

export default component.exports